module.exports = __webpack_public_path__ + "static/media/android-original-wordmark.c8c3e2ce.svg";